// Utils
import { isWebBridgeSupported } from '@shopee/web-bridge-sdk';

// Types
import type { AddOrChangePasswordExitHandling } from '@shopee-user/business-customization-types';

export function addOrChangePasswordExitHandling({
  nonce,
  isWebViewLogoutAfterCredentialChangeEnabled,
  isUserPasswordWebLogoutAfterCredentialChangeEnabled,
  webViewLogoutSuccessfully,
  webViewNotifyRefreshTokenAfterChangeCredentials,
  exitWithSuccess,
  safelyRedirectToNextUrlFromQueryString,
}: AddOrChangePasswordExitHandling) {
  if (isWebBridgeSupported()) {
    if (isWebViewLogoutAfterCredentialChangeEnabled) {
      webViewLogoutSuccessfully();
    } else {
      webViewNotifyRefreshTokenAfterChangeCredentials({ nonce });
      exitWithSuccess();
    }
  } else {
    safelyRedirectToNextUrlFromQueryString({
      ...(!isUserPasswordWebLogoutAfterCredentialChangeEnabled && {
        code: nonce,
      }),
    });
  }
}
